import { STORYBOOK_HOST } from "@/constants";

export const isStoryBookDomain =
  window.location.port === "6006" || window.location.host === STORYBOOK_HOST;
